// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".30384b7c535f3585e3f9086f3acf4d653db95e72.chunk.bundle.js";
};